var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _c("div", { staticClass: "mb-2" }, [
        _c("div", { staticClass: "font-16 color-black" }, [
          _vm._v(" Categoría: ")
        ]),
        _c("div", { staticClass: "font-14 color-gray-6" }, [
          _vm._v(
            " " +
              _vm._s(_vm._f("empty")(_vm.item.determinationCategory?.name)) +
              " "
          )
        ])
      ]),
      _vm._m(1),
      _vm.pagination.items.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay documentos asociados." }
          })
        : _c(
            "div",
            [
              _vm._l(_vm.pagination.items, function(doc) {
                return _c(
                  "div",
                  {
                    key: doc.id,
                    staticClass: "rounded p-3 bg-secondary-3 my-3"
                  },
                  [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-md" }, [
                        _c("div", { staticClass: "data-name" }, [
                          _vm._v("Archivo:")
                        ]),
                        _c("div", [_vm._v(_vm._s(_vm._f("empty")(doc.name)))])
                      ]),
                      _c("div", { staticClass: "col-12 col-md" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-end mt-1" },
                          [
                            _c("action-button", {
                              attrs: {
                                i: "fas fa-file-download icon-mr-0",
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.download(doc)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ])
                  ]
                )
              }),
              _vm.pagination.totalItemCount > _vm.pagination.pageSize
                ? _c("pagination", {
                    attrs: { data: _vm.pagination, "show-text": "" },
                    on: { "pagination-go-page": _vm.search }
                  })
                : _vm._e()
            ],
            2
          ),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end align-items-center mt-4" },
        [
          _c("action-button", {
            attrs: {
              i: "fas fa-times-circle",
              text: "Cerrar",
              variant: "outline-danger mr-2"
            },
            on: { click: _vm.close }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-2" }, [
      _c("i", { staticClass: "mr-2 fas fa-file mb-1 text-orange" }),
      _c("label", { staticClass: "font-16 color-black font-weight-bold" }, [
        _vm._v(" Determinación ")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mt-3" }, [
      _c("i", { staticClass: "mr-2 fas fa-file mb-1 text-orange" }),
      _c("label", { staticClass: "font-16 color-black font-weight-bold" }, [
        _vm._v(" Documentos ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }